module.exports = __webpack_public_path__ + "static/media/A7407800.f4ad1b0e.jpg";